import { tracker } from '@ixigo/analytics';

import { createContext, useContext, useMemo } from 'react';

type TrackerContextValue = {
	track: typeof tracker.track;
};

const TrackerContext = createContext<TrackerContextValue>({
	track: tracker.track,
});

/**
 * use it to shared track function to all the children components
 * useful when a component/widget is used across funnels and athe parent funnel has common attributes and needed to be attached to the child events
 */
export function TrackerProvider({
	children,
	track,
}: {
	children: React.ReactNode;
	track: TrackerContextValue['track'];
}) {
	const value = useMemo(() => ({ track }), [track]);
	return (
		<TrackerContext.Provider value={value}>{children}</TrackerContext.Provider>
	);
}

export function useTracker() {
	return useContext(TrackerContext);
}
